import './PatentApplicationsListItem.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

export default function PatentApplicationsListItem({user, applicationItem, isMobile}) {


    return (
    <tr className='PatentApplicationsListItem'>
        <td className='RPNumber'>
            {applicationItem.RPNumber? 
            <div>
                {applicationItem.RPNumber}
            </div>
            :
            '---'
            }
        </td>
        <td className='applicationNumber'>
            {applicationItem.applicationNumber? applicationItem.applicationNumber:'---'}
        </td>
        <td className='applicationType'>
            {applicationItem.applicationType?
            <>
            {applicationItem.applicationType === 'nonProvisional' ? 'Non-Provisional' : capitalizeFirstLetter(applicationItem.applicationType)}
            </>
            :
            '---'
            }
        </td>
        <td className='filingDate dateField'>
            <div>
                {applicationItem.filingDate? new Date(applicationItem.filingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        <td className='title'>
            {applicationItem.title? capitalizeFirstLetter(applicationItem.title):'---'}
        </td>
        <td className='applicationStatus'>
            {applicationItem.applicationStatus? 
            <>
            {applicationItem.applicationStatus === 'officeActionIssued' ? 'Office Action Issued' : applicationItem.applicationStatus === 'NOAIssued' ? 'NOA Issued' : applicationItem.applicationStatus === 'awaitingExam' ? 'Awaiting Exam' : capitalizeFirstLetter(applicationItem.applicationStatus)}
            </>
            :'---'
            }
        </td>
        <td className='inventors'>
            {applicationItem.inventors? capitalizeFirstLetter(applicationItem.inventors):'---'}
        </td>
        <td className='country'>
            {applicationItem.country? applicationItem.country.toUpperCase():'---'}
        </td>
        <td className='patentType'>
            {applicationItem.patentType? capitalizeFirstLetter(applicationItem.patentType):'---'}
        </td>
        <td className='earliestPriorityDate dateField'>
            <div>
                {applicationItem.earliestPriorityDate? new Date(applicationItem.earliestPriorityDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        <td className='earliestPriorityApplicationNumber'>
            {applicationItem.earliestPriorityApplicationNumber? applicationItem.earliestPriorityApplicationNumber:'---'}
        </td>
        <td className='nextAction'>
            {applicationItem.nextAction? applicationItem.nextAction:'---'}
        </td>
        <td className='nextActionDueDate dateField'>
            <div>
                {applicationItem.nextActionDueDate? new Date(applicationItem.nextActionDueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        <td className='publicationDate dateField'>
            <div>
                {applicationItem.publicationDate? new Date(applicationItem.publicationDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
    </tr>
  )
}
